import React from 'react';

import Icon from './square-icons/gallery.png';

const SquareGalleryIcon = () => {
  return (
    <img
      style={{ height: 30, width: 30 }}
      src={Icon}
      alt="square-gallery-icon"
    />
  );
};

export default SquareGalleryIcon;
